import { Logo } from "./Logo";
import { FOOTER_LINKS, SOURCES_NOTE } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => (
  <footer className="border-t border-[#bdbdb4] bg-[#f5f5ee]" data-testid="site-footer">
    <div className="mx-auto max-w-[1360px] px-5 py-14 sm:px-8">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo className="h-10" testId="footer-logo" />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#55554f]">Compliance OS for hardware suppliers</p>
        </div>
        <nav className="grid grid-cols-2 gap-x-8 gap-y-3 sm:grid-cols-3 lg:col-span-7" aria-label="Footer">
          {FOOTER_LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={(e) => { e.preventDefault(); scrollToId(l.id); }}
              className="cd-navlink w-fit text-sm text-[#292929]"
              data-testid={`footer-link-${l.id}`}
            >
              {l.label}
            </a>
          ))}
        </nav>
      </div>
      <div className="mt-14 flex flex-col gap-3 border-t border-[#e2e2da] pt-6 font-mono text-[11px] text-[#77776f] md:flex-row md:items-center md:justify-between">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Condoor. All rights reserved.</p>
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:gap-6">
          <p data-testid="footer-sources">{SOURCES_NOTE}</p>
          <a href="/download" className="w-fit text-[#94948a] underline-offset-4 transition-colors hover:text-[#55554f] hover:underline" data-testid="footer-download-source-link">Download source</a>
        </div>
      </div>
    </div>
  </footer>
);
